export enum TransactionApiUrls {
  AccountTransfer = "/v1/AccountTransfer",
  AccountTransferV2 = "/v2/AccountTransfer",
  AccountHolder = "/v1/Accounts/:accountId/Holder",
  AccountTransferCommission = "/v1/AccountTransfer/Commission",
  Beneficiary = "/v1/Beneficiaries",
  BudgetTransfer = "/v1/BudgetTransfer",
  BudgetTransferV2 = "/v2/BudgetTransfer",
  BudgetTransferCommission = "/v1/BudgetTransfer/Commission",
  CardTransfer = "/v1/CardTransfer",
  CardTransferV2 = "/v2/CardTransfer",
  CardTransferCommission = "/v1/CardTransfer/Commission",
  CurrencyExchange = "/v1/CurrencyExchange",
  CurrencyExchangeV2 = "/v2/CurrencyExchange",
  GroupTransfer = "/v1/GroupTransfer",
  GroupTransferV2 = "/v2/GroupTransfer",
  GroupTransferCommission = "/v1/GroupTransfer/Commission",
  OwnAccountTransfer = "/v1/OwnAccountTransfer",
  OwnAccountTransferV2 = "/v2/OwnAccountTransfer",
  TransferUrgentAvailable = "/v1/Transactions/UrgentTransfer/Availability",
  TransferTransactionNumber = "/v1/Transactions/SequenceNumber",
  TransferSign = "/v1/Transactions/Sign",
  TransactionsTypes = "/v1/Transactions/Types",
  Transactions = "/v1/Transactions",
  TransactionsState = "/v1/Transactions/:id/State",
  BudgetAccounts = "/v1/Directory/BudgetAccounts",
  RegionCodes = "/v1/Directory/RegionCodes",
  TaxPayers = "/v1/Directory/TaxPayers",
  PersonalizedExchangeRate = "/v1/ExchangeRates/Personalized",
  LoanRepayment = "/v1/LoanRepayment",
  LoanRepaymentV2 = "/v2/LoanRepayment",
}

export enum Paths {
  Transactions = "transactions",
  TransactionHistory = "history/transaction",
  OwnAccountsTransfer = "transfer/own-account",
  OwnAccountsTransferUpdate = "transfer/own-account/:operationId/update",
  OwnAccountsTransferCopy = "transfer/own-account/:operationId/copy",
  AccountTransfer = "transfer/account",
  AccountTransferUpdate = "transfer/account/:operationId/update",
  AccountTransferCopy = "transfer/account/:operationId/copy",
  CardTransfer = "transfer/card",
  CardTransferUpdate = "transfer/card/:operationId/update",
  CardTransferCopy = "transfer/card/:operationId/copy",
  BudgetTransfer = "transfer/budget",
  BudgetTransferUpdate = "transfer/budget/:operationId/update",
  BudgetTransferCopy = "transfer/budget/:operationId/copy",
  CurrencyExchange = "transfer/currency-exchange",
  CurrencyExchangeUpdate = "transfer/currency-exchange/:operationId/update",
  CurrencyExchangeCopy = "transfer/currency-exchange/:operationId/copy",
  GroupTransfer = "transfer/group",
  GroupTransferUpdate = "transfer/group/:operationId/update",
  GroupTransferCopy = "transfer/group/:operationId/copy",
  DepositTerminationApplication = "deposit-termination",
  LoanRepayment = "transfer/loan-repayment",
  LoanRepaymentUpdate = "transfer/loan-repayment/:operationId/update",
  LoanRepaymentCopy = "transfer/loan-repayment/:operationId/copy",
}

export enum TransferKeys {
  Beneficiary = "beneficiary",
  Purpose = "purpose",
  Account = "account",
  Amount = "amount",
  Currency = "currency",
  DebitAccount = "debitAccount",
  TransactionNumber = "transactionNumber",
  ScheduleDate = "scheduleDate",
  CreditAccount = "creditAccount",
  CommissionData = "commissionData",
  BankName = "bankName",
  BeneficiaryLegalStatus = "beneficiaryLegalStatus",
  IsUrgent = "isUrgent",
  TemplateName = "templateName",
  IsSaveAsTemplate = "isSaveAsTemplate",
}

export enum CardTransferKeys {
  CreditCardNumber = "creditCardNumber",
}

export enum BudgetTransferKeys {
  PartyType = "authorizedBudgetTransferParty.partyType",
  Residency = "authorizedBudgetTransferParty.residency",
  Tin = "authorizedBudgetTransferParty.tin",
  Ssn = "authorizedBudgetTransferParty.ssn",
  CreditBudgetAccount = "creditBudgetAccount",
  RegionCode = "regionCode",
  IsAuthorizedTransfer = "isAuthorizedTransfer",
  DocumentType = "authorizedBudgetTransferParty.documentType",
  DocumentNumber = "authorizedBudgetTransferParty.documentNumber",
}

export enum CurrencyExchangeKeys {
  IsRateChangeAcceptable = "isRateChangeAcceptable",
  Rate = "rate",
  WantAmount = "wantAmount",
}

export enum LoanRepaymentKeys {
  LoanRepaymentType = "loanRepaymentType",
  LoanContractNumber = "loanContractNumber",
}

export enum ResidenceType {
  Resident = "Resident",
  NonResident = "NonResident",
}

export enum PartyType {
  NaturalPerson = "NaturalPerson",
  LegalEntity = "LegalEntity",
  PrivateEntrepreneur = "PrivateEntrepreneur",
}

export enum DocumentType {
  RAPassport = "RAPassport",
  ForeignPassport = "ForeignPassport",
  DeathCertificate = "DeathCertificate",
}

export enum TransactionTypes {
  AccountTransfer = "AccountTransfer",
  CardTransfer = "CardTransfer",
  BudgetTransfer = "BudgetTransfer",
  GroupTransfer = "GroupTransfer",
  CurrencyExchange = "CurrencyExchange",
  OwnAccountTransfer = "OwnAccountTransfer",
  LoanRepayment = "LoanRepayment",
}

export enum TransactionApiTagTypes {
  TransactionHistory = "TransactionHistory",
}

export enum BankAccountPrefix {
  Ameria = "157",
  Acba = "220",
  Amio = "115",
  ID = "118",
  Ararat = "151",
  Ardshin = "247",
  Armswiss = "250",
  Artsakh = "223",
  Byblos = "214",
  Evoca = "166",
  Ineco = "205",
  Convers = "193",
  Armeconom = "163",
  Mellat = "208",
  Uni = "241",
  Vtb = "160",
  Fast = "262",
}

export enum TransactionTab {
  Transfers = "transfers",
  Payments = "payments",
}

export enum TransactionFeatureToggles {
  CardTransfer = "isCardTransferAvailable",
  BudgetTransfer = "isBudgetTransferAvailable",
  AccountTransfer = "isAccountTransferAvailable",
  OwnAccountTransfer = "isOwnAccountTransferAvailable",
  CurrencyExchange = "isCurrencyExchangeAvailable",
  GroupTransfer = "isGroupTransferAvailable",
  LoanRepayment = "isLoanRepaymentAvailable",
}


export enum TransactionActionFeatureToggles {
  CardTransferEdit = "isCardTransferUpdateAvailable",
  CardTransferCopy = "isCardTransferCopyAvailable",
  BudgetTransferEdit = "isBudgetTransferUpdateAvailable",
  BudgetTransferCopy = "isBudgetTransferCopyAvailable",
  AccountTransferEdit = "isAccountTransferUpdateAvailable",
  AccountTransferCopy = "isAccountTransferCopyAvailable",
  OwnAccountTransferEdit = "isOwnAccountTransferUpdateAvailable",
  OwnAccountTransferCopy = "isOwnAccountTransferCopyAvailable",
  CurrencyExchangeEdit = "isCurrencyExchangeUpdateAvailable",
  CurrencyExchangeCopy = "isCurrencyExchangeCopyAvailable",
  GroupTransferEdit = "isGroupTransferUpdateAvailable",
  GroupTransferCopy = "isGroupTransferCopyAvailable",
  LoanRepaymentEdit = "isLoanRepaymentUpdateAvailable",
  LoanRepaymentCopy = "isLoanRepaymentCopyAvailable",
}

export enum LoanRepaymentType {
  RegularRepayment = "RegularRepayment",
  PrincipalRepayment = "PrincipalRepayment",
  FullRepayment = "FullRepayment",
}

export enum LoanRepaymentStatus {
  NoOverdue = "NoOverdue",
  Overdue = "Overdue",
}

export enum LoanPenalties {
  OverdueSubsidy = "overdueSubsidy",
  Subsidy = "subsidy",
}

export enum BeneficiaryLegalStatus {
  NotSet = "NotSet",
  Legal = "Legal",
  Natural = "Natural",
}

export enum BeneficiaryLegalStatusTranslationKey {
  Legal = "legal",
  Natural = "natural",
}

export enum RegionCodeType {
  Tax = "Tax",
  Custom = "Custom",
  Other = "Other",
}
